import { createAsyncThunk } from '@reduxjs/toolkit';
import getResourcesOfProjectWithEmployerData from '../services/getResourcesOfProjectWithEmployerData';
export const loadResourcesOfProjectWithEmployerData = createAsyncThunk(
  'common/loadResourcesOfProjectWithEmployerData',
  async (projectId) => {
    const response = await getResourcesOfProjectWithEmployerData(projectId);
    return response;
  }
);
